function removeEmpty(obj): any {
  const newObj = {};
  Object.keys(obj).forEach((k) => {
    if (obj[k] && typeof obj[k] === 'object') {
      newObj[k] = removeEmpty(obj[k]);
    } else if (obj[k] != null && typeof obj[k] !== 'undefined') {
      newObj[k] = obj[k];
    }
  });
  return newObj;
}


export function objectToQueryParams(obj: object): string {
  const notEmpty = obj && typeof obj !== 'undefined' && Object.keys(obj).length > 0;

  if (notEmpty) {
    obj = removeEmpty(obj);
    return '?' + Object.keys(obj).map(key => `${key}=${obj[key]}`).join('&');
  }

  return '';
}
